import React, { useState } from "react";
import { Divider, Drawer, IconButton } from "react-native-paper";
import { View, Dimensions, Image, ScrollView } from "react-native";
import StyleSheet from "react-native-media-query";
import logo from "../../../assets/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { setIsDrawerVisible } from "../../store/slices/generalSlice";
import {
  appBarColor,
  primaryColor,
  sidebarColor,
} from "../../constant/constantCss";
import { PERMISSION } from "../../constant/getAllPermission";
import LogoutModal from "../Logout/LogoutModal";

const AppDrawer = ({ activeItem, navigateToScreen }) => {
  const { isDrawerVisible } = useSelector((state) => state.general);
  const [isVisibleLogoutModal, setIsVisibleLogoutModal] = useState(false);
  const { permission } = useSelector((state) => state.auth);
  const screenHeight = Dimensions.get("window").height;
  const dispatch = useDispatch();
  const { ids, styles } = StyleSheet.create({
    img: {
      marginLeft: 50,
      height: 80,
      width: 150,
      marginBottom: 20,
      "@media (min-width: 768px)": {
        marginTop: 20,
      },
    },
    drawerContainer: {
      flex: 1,
      zIndex: 1,
      height: "100%",
      minWidth: 250,
      display: isDrawerVisible ? "block" : "none",
      position: "fixed",
      backgroundColor: appBarColor,
      borderRightWidth: 1,
      borderRightColor: "#D8D8D8",
      overflow: "auto",

      "@media (max-width: 768px)": {
        borderTopRightRadius: 40,
        borderBottomRightRadius: 40,
      },
    },
    itemContainer: {
      borderRadius: 0,
    },
    activeItemContainer: {
      borderRadius: 0,
      borderTopRightRadius: 40,
      borderBottomRightRadius: 40,
      backgroundColor: sidebarColor,
    },
    mainContainer: {
      width: 250,
      minHeight: screenHeight,
      "@media (max-width: 768px)": {
        position: "absolute",
        zIndex: 10,
      },
    },
    backMenuContainer: {
      display: "flex",
      height: 64,
      alignItems: "flex-end",
      "@media (min-width: 768px)": {
        display: "none",
      },
    },
  });
  return (
    <>
      {isDrawerVisible ? (
        <View
          style={styles.mainContainer}
          dataSet={{ media: ids.mainContainer }}
        >
          <View
            style={styles.drawerContainer}
            dataSet={{ media: ids.drawerContainer }}
          >
            <ScrollView style={{ height: screenHeight }}>
              <Drawer.Section>
                <View
                  style={styles.backMenuContainer}
                  dataSet={{ media: ids.backMenuContainer }}
                >
                  <IconButton
                    icon={"menu-open"}
                    style={{
                      borderRadius: 10,
                      borderWidth: 1,
                      marginTop: 40,
                      backgroundColor: sidebarColor,
                      borderColor: primaryColor,
                    }}
                    onPress={() =>
                      dispatch(setIsDrawerVisible(!isDrawerVisible))
                    }
                    animated={true}
                  />
                </View>
                <Image
                  source={logo}
                  style={styles.img}
                  dataSet={{ media: ids.img }}
                />
                <Drawer.Item
                  label="Dashboard"
                  icon="home"
                  style={
                    activeItem === "Dashboard"
                      ? styles.activeItemContainer
                      : styles.itemContainer
                  }
                  active={activeItem === "Dashboard"}
                  onPress={() => navigateToScreen("Dashboard")}
                />
                <Divider />
                <Drawer.Item
                  label="Trips"
                  icon="camera-image"
                  style={
                    activeItem === "Trip"
                      ? styles.activeItemContainer
                      : styles.itemContainer
                  }
                  active={activeItem === "Trip"}
                  onPress={() => navigateToScreen("Trip")}
                />
                {permission &&
                  permission?.includes(
                    PERMISSION.CAN_SHOW_ORGANIZATION_DETAILS_TAB
                  ) && (
                    <React.Fragment>
                      <Divider />
                      <Drawer.Item
                        label="Organization Details"
                        icon="bank"
                        style={
                          activeItem === "Manage_School_Details"
                            ? styles.activeItemContainer
                            : styles.itemContainer
                        }
                        active={activeItem === "Manage_School_Details"}
                        onPress={() =>
                          navigateToScreen("Manage_School_Details")
                        }
                      />
                    </React.Fragment>
                  )}
                <Divider />

                {permission &&
                  permission?.includes(
                    PERMISSION.CAN_SHOW_ROLE_MANAGEMENT_TAB
                  ) && (
                    <>
                      <Divider />
                      <Drawer.Item
                        label="Role Management"
                        icon="shield-account"
                        style={
                          activeItem === "Role_Management"
                            ? styles.activeItemContainer
                            : styles.itemContainer
                        }
                        active={activeItem === "Role_Management"}
                        onPress={() => navigateToScreen("Role_Management")}
                      />
                    </>
                  )}
                {permission &&
                  permission?.includes(PERMISSION.CAN_SHOW_ALL_USERS_TAB) && (
                    <>
                      <Divider />
                      <Drawer.Item
                        label="All Users"
                        icon="account-group"
                        style={
                          activeItem === "All_User"
                            ? styles.activeItemContainer
                            : styles.itemContainer
                        }
                        active={activeItem === "All_User"}
                        onPress={() => navigateToScreen("All_User")}
                      />
                    </>
                  )}

                <Divider />
                <Drawer.Item
                  label="Profile"
                  icon="account"
                  style={
                    activeItem === "Profile"
                      ? styles.activeItemContainer
                      : styles.itemContainer
                  }
                  active={activeItem === "Profile"}
                  onPress={() => navigateToScreen("Profile")}
                />
                <Divider />
                <Drawer.Item
                  label="Payment History"
                  icon="credit-card"
                  style={
                    activeItem === "Payment_History"
                      ? styles.activeItemContainer
                      : styles.itemContainer
                  }
                  active={activeItem === "Payment_History"}
                  onPress={() => navigateToScreen("Payment_History")}
                />
                {permission &&
                  permission?.includes(
                    PERMISSION.CAN_SHOW_ANALYTICS_OVERVIEW_TAB
                  ) && (
                    <>
                      <Divider />
                      <Drawer.Item
                        label="Analytics Overview"
                        icon="chart-line"
                        style={
                          activeItem === "Analytics"
                            ? styles.activeItemContainer
                            : styles.itemContainer
                        }
                        active={activeItem === "Analytics"}
                        onPress={() => {
                          navigateToScreen("Analytics");
                        }}
                      />
                    </>
                  )}
                {permission &&
                  permission?.includes(
                    PERMISSION.CAN_SHOW_ANALYTICS_TRIP_TAB
                  ) && (
                    <>
                      <Divider />
                      <Drawer.Item
                        label="Analytics Trip"
                        icon="chart-line"
                        style={
                          activeItem === "Analytics_Trip"
                            ? styles.activeItemContainer
                            : styles.itemContainer
                        }
                        active={activeItem === "Analytics Trip"}
                        onPress={() => {
                          navigateToScreen("Analytics_Trip");
                        }}
                      />
                    </>
                  )}
                <Divider />
                {permission &&
                  permission?.includes(
                    PERMISSION.CAN_SHOW_COMPANY_REVIEW_TAB
                  ) && (
                    <>
                      <Divider />
                      <Drawer.Item
                        label="Company Reviews"
                        icon="star"
                        style={
                          activeItem === "Company_Review"
                            ? styles.activeItemContainer
                            : styles.itemContainer
                        }
                        active={activeItem === "Company Review"}
                        onPress={() => {
                          navigateToScreen("Company_Review");
                        }}
                      />
                    </>
                  )}
                <Divider />
                <Drawer.Item
                  label="Logout"
                  icon="logout"
                  style={
                    activeItem === "Logout"
                      ? styles.activeItemContainer
                      : styles.itemContainer
                  }
                  active={activeItem === "Logout"}
                  onPress={() => setIsVisibleLogoutModal(true)}
                />
              </Drawer.Section>
              {isVisibleLogoutModal && (
                <LogoutModal
                  visible={isVisibleLogoutModal}
                  handleClose={() => setIsVisibleLogoutModal(false)}
                />
              )}
            </ScrollView>
          </View>
        </View>
      ) : (
        <></>
      )}
    </>
  );
};

export default AppDrawer;
